const API_URL = process.env.REACT_APP_API_URL;

async function parseJsonResponse(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(data.error || 'Request failed');
    }
    return data;
}

export async function saveLaunchContact({ screenId, email, phone, page, launchPageId }) {
    const res = await fetch(`${API_URL}/launch/lead`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            screenId,
            email,
            phone,
            ...(page ? { page } : {}),
            ...(launchPageId ? { launchPageId } : {}),
        }),
    });
    return parseJsonResponse(res);
}

export async function updateLaunchLead(launchLeadId, payload) {
    const res = await fetch(`${API_URL}/launch/lead/${encodeURIComponent(launchLeadId)}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    return parseJsonResponse(res);
}
